<script setup lang="ts">
import { retrieveRedirectUrlFromAppState } from '@/helpers/Authentication/authClient';
import { isPlatformIs24 } from '@/helpers/platformDetection';
import { onMounted } from 'vue';

onMounted(async () => {
  const redirectUrl = await retrieveRedirectUrlFromAppState();

  const fallbackRedirectUrl = isPlatformIs24()
    ? `${import.meta.env.VUE_APP_PLATFORM_ACCOUNT_BASE_URL}/de/account-overview`
    : `${import.meta.env.VUE_APP_PLATFORM_ACCOUNT_BASE_URL}/de/overview`;

  window.location.href = redirectUrl ? redirectUrl : fallbackRedirectUrl;
});
</script>

<template>
  <div>
    <p>Wir leiten Sie in Kürze weiter</p>
  </div>
</template>
